import { render } from "./SocialItems.vue?vue&type=template&id=33e21df6&lang=pug"
import script from "./SocialItems.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialItems.vue?vue&type=script&setup=true&lang=js"

import "./SocialItems.vue?vue&type=style&index=0&id=33e21df6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__